import React, { Component, useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import { SpaceBox } from "../../components/Space";
import ConsentInter from "../../data/consent/inter";
import ConsentMenu from "../../components/consentMenu";
import DocumentList from "../../components/consentMenu/document-list";
import DocumentData from "../../data/consent/documents/inter";
class ConsentPage extends Component {
  state = {
    // benefitHTML: ,
    conditionHTML: this.buildCondition(),
    serviceHTML: this.buildService(),
    menuTab: 1,
    toggleEvent: {
      "0": true,
      "1": false
    }
  };

  componentDidMount() {
    window.scrollTo(0,0);
  }
  onChangeTab(value) {
    this.setState({ menuTab: value });
  }
  buildBenefit() {
    const { benefits } = ConsentInter;
    return benefits.map((benefit, index) => {
      return (
        <Card className="consent-benefit">
          <CustomToggle
            className="accordion-toggle"
            eventKey={`${index}`}
            toggleKey={this.state.toggleEvent}
            onToggleChange={(eventKey) => {
              const toggle = this.state.toggleEvent[eventKey];
              this.setState({...this.state, toggleEvent: { [eventKey]: !toggle} })
            }}
          >
            <h6 name="toggle">{benefit.title}</h6>
          </CustomToggle>
          <Accordion.Collapse eventKey={`${index}`}>
            <Card.Body>
              <p className="text-blue-light">{benefit.detail}</p>
              {benefit.items.map((item, index) => {
                return (
                  <>
                    <p className="normal-text mb-1">{item.index}</p>
                    {item.ranges.map((range) => {
                      return (
                        <>
                          <p className="range-text mb-2">{range.name}</p>
                          {range.plans.map((plan) => {
                            return (
                              <>
                                <div className="price-text">
                                  <span>{plan.name}</span>
                                  <p className="mb-0 ml-auto">{plan.price}</p>
                                </div>
                              </>
                            );
                          })}
                        </>
                      );
                    })}
                  </>
                );
              })}
              <div className="line-gray"></div>
              <p className="text-blue-light">ระยะเวลาเอาประกันภัย</p>
              {benefit.times.map((time) => {
                return (
                  <>
                    <p className="range-text mb-1">{time.day}</p>
                    <span className="text-sub">เบี้ยประกันภัย (บาท)</span>
                    <div className="table-time">
                      <table width="100%">
                        <thead>
                          <tr className="t-head">
                            <td></td>
                            {benefit.timesHeaders.map((e) => (
                              <td className="text-right">{e}</td>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr className={`t-body ${index == 1 ? "2col" : ""}`}>
                            <td>
                              <b>ASIA</b>
                            </td>
                            {benefit.timesHeaders.map((e) => (
                              <td className="text-right">{time.asia[e]}</td>
                            ))}
                          </tr>
                          <tr className="t-body">
                            <td>
                              <b>WORLDWIDE</b>
                            </td>
                            {benefit.timesHeaders.map((e) => (
                              <td className="text-right">
                                {time.worldwide[e]}
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                );
              })}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      );
    });
  }
  buildCondition() {
    const { conditions } = ConsentInter;
    return conditions.map((condition, index) => {
      return (
        <Card className="consent-benefit pt-3">
            <Card.Body>
              <p className="text-blue-light">{condition.detail}</p>
              {condition.items.map((item) => {
                return (
                  <>
                    <label className="normal-text mb-1">{item.index}</label>
                  </>
                );
              })}
              {this.Exception()}
            </Card.Body>
        </Card>
      );
    });
  }
  Exception() {
    const { exceptions } = ConsentInter;

    return exceptions.map((exception, index) => {
      return (
        <div className="consent-benefit">
          <p className="text-blue-light mt-3">{exception.detail}</p>
          {exception.items.map((item) => {
            return (
              <>
                <label className="normal-text mb-1">{item.index}</label>
              </>
            );
          })}
        </div>
      );
    });
  }
  buildService() {
    const { services } = ConsentInter;

    return services.map((service, index) => {
      return (
        <Card className="consent-benefit">
            <Card.Body>
              <p
                className="text-blue-light mt-3"
                dangerouslySetInnerHTML={{ __html: service.detail }}
              ></p>
              {service.items.map((item) => {
                return (
                  <>
                    <label
                      className="normal-text mb-0"
                      dangerouslySetInnerHTML={{ __html: item.index }}
                    ></label>
                  </>
                );
              })}
            </Card.Body>
        </Card>
      );
    });
  }
  render() {
    const { benefitHTML, conditionHTML, serviceHTML, menuTab } = this.state;

    return (
      <div className="consent">
        <div className="consent-panel normal-text">
          <h5>{ConsentInter.title}</h5>
          <p dangerouslySetInnerHTML={{ __html: ConsentInter.description }}></p>
        </div>
        <div className="consent-panel mb-0 pb-5">
          <ConsentMenu
            onChangeTab={(value) => this.onChangeTab(value)}
            menuTab={menuTab}
          />
          {menuTab === 1 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">{this.buildBenefit()}</Accordion>
            </div>
          ) : menuTab === 2 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">{conditionHTML}</Accordion>
            </div>
          ) : menuTab === 3 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">{serviceHTML}</Accordion>
              <div className="mt-5 text-center">
                <span
                  className="btn btn-primary btn-block"
                  style={{ backgroundColor: "#55b3f9", borderRadius: "20px", border: "1px solid #55b3f9" }}
                  onClick={() => { window.location.href = "https://www.mticonnect.com/Contact/Information/Ta" }}
                >
                  ติดต่อสอบถาม
                </span>
              </div>
            </div>
          ) : menuTab === 4 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">
                <DocumentList data={DocumentData}/>
              </Accordion>
            </div>
          ) : (
            ""
          )}
        </div>
        {/* <SpaceBox w="1px" h="34px" /> */}
      </div>
    );
  }
}

function CustomToggle({ init, children, eventKey, toggleKey, onToggleChange }) {
  const decoratedOnClick = useAccordionToggle(eventKey);

  const onToggle = (e) => {
    e.stopPropagation();
    if(onToggleChange) {
      onToggleChange(eventKey)
    }
    decoratedOnClick();
  };

  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 1);

  return (
    <Card.Header
      className={`d-flex accordion-header ${toggleKey[eventKey] ? "toggle" : ""}`}
      name="toggle"
      onClick={(e) => onToggle(e)}
    >
      {children}
      <img
        className="ml-auto"
        src={toggleKey[eventKey] ? SpanMoreTabTop : SpanMoreTabDown}
        width="24px"
        height="24px"
        alt="span image"
        style={{ marginRight: "4px" }}
      />
    </Card.Header>
  );
}

export default ConsentPage;
